<div class="form-item" [formGroup]="form">

  <ng-container [ngSwitch]="field.controlType">

    <mat-form-field class="mat-field" *ngSwitchCase="'input'">

      <input matInput [formControlName]="field.key"
             [placeholder]="field.placeholder"
             [required]="hasRequiredAttribute">
      <mat-error>
        <ng-container *ngIf="isRequired">{{ field.placeholder }} is required</ng-container>
      </mat-error>

    </mat-form-field>

    <div class="mat-field checkbox" *ngSwitchCase="'checkbox'">

      <mat-checkbox [formControlName]="field.key">{{ field.placeholder }}</mat-checkbox>

    </div>

    <mat-form-field class="mat-field checkbox" *ngSwitchCase="'textarea'">

      <textarea matInput [formControlName]="field.key"
                [placeholder]="field.placeholder"
                [required]="hasRequiredAttribute"
      ></textarea>

    </mat-form-field>


  </ng-container>

</div>
